/**
 * AppleSignInButton — «Continua con Apple» (#31).
 *
 * Nero sui temi chiari e bianco su quelli scuri, col logo, come chiedono le
 * Human Interface Guidelines di Apple. Il logo è U+F8FF, che i font di sistema
 * Apple disegnano come la mela: il pulsante esiste solo su iOS
 * (appleSignInAvailable), quindi non serve un'immagine.
 */
import React from "react";
import { useTranslation } from "react-i18next";

export default function AppleSignInButton({ onClick, busy, dark }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={busy ? undefined : onClick}
      disabled={busy}
      data-testid="signin-apple"
      style={{
        width: "100%",
        minHeight: 48,
        padding: "12px 20px",
        border: "none",
        borderRadius: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: 17,
        fontWeight: 600,
        background: dark ? "#fff" : "#000",
        color: dark ? "#000" : "#fff",
        cursor: busy ? "default" : "pointer",
        opacity: busy ? 0.6 : 1,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: 19, lineHeight: 1 }}>{""}</span>
      {t("ui.signIn.apple")}
    </button>
  );
}
